module.exports = __webpack_public_path__ + "static/media/Applen music.1335bad8.svg";